// Canonical RCKT brand assets — reference this single source everywhere.
export const HANDSTYLE = "/rckt-handstyle.png";
export const INSTAGRAM_URL = "https://www.instagram.com/racket.archives/";
export const NAV_INSTAGRAM_URL = "https://www.instagram.com/rckt.archives/";
export const CONTACT_EMAIL = "officially.rckt@gmail.com";
